﻿/* 
Object:         Form
Description:    Logic around submitting a form. Gives feedback to the user in a simple manner. Redirects users back or forward. 
Used in:        Forms, TagHelper (submit button)
*/

window.form = function () {

    const WAIT_DELAY = 3000;

    /**
     * submit form with action. Report result back by calling showResult
     * @param {string} idForm
     * @param {string} actionUrl
     * @param {boolean} navigateBack
     * @param {string} kendoWindowId
     */
    function submitFormWithFile(formId, actionUrl, navigateBack, kendoWindowId) {
        var validator = $('#' + formId).kendoValidator().data('kendoValidator');

        if (validator.validate()) {

            // Serialize form data
            var formData = new FormData($('#' + formId)[0]);

            $.ajax({
                url: appsettings.getUrl(actionUrl),
                type: 'POST',
                data: formData,
                /*The processData and contentType options are set to false to prevent jQuery from processing the data or setting the content type, respectively.
                 *This is necessary when sending binary data, such as a file. */
                processData: false,
                contentType: false,

                success: function (responseData) {

                    inputs.removeDirtyInput(); // remove dirty input

                    // redirect
                    if (responseData.RedirectTo != undefined) {

                        // succesfull callback 
                        if (responseData.Succesfully) {
                            location.href = appsettings.getUrl(responseData.RedirectTo);
                        }

                    }
                    else // if not
                    {
                        // Show request result
                        form.showServerResponse(formId, responseData);

                        if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                            Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                        }

                        // When navigate back is true (as property given 'taghelper') and request is successfull. 
                        if (navigateBack && responseData.Succesfully) {

                            if (kendoWindowId == "") {
                                if (history.length > 2) {
                                    history.back(); // go back one page using the breadcrumb hist.
                                }
                            } else {
                                var kendoWindow = $(kendoWindowId).data("kendoWindow");

                                if (kendoWindow !== undefined) {
                                    kendoWindow.close();
                                }
                            }

                        }
                    }
                }
            });
        }
    }


    function onHide(callBack) {
        if (callBack != null && callBack != undefined) {
            setTimeout(callBack, WAIT_DELAY);
        }
    }

    return {
        initialize: function () {

            // Attach onchange event handler to all Kendo inputs
            $('input.k-input').on('change', function () {

                // Your onchange code goes here
                console.log('input changed!');
            });

            // Show required tagged inputs
            $("input[input-precom-required = 'true']").parent().css("border-left", "3px solid red");
        },

        /**
         * submit the data (model) and give the user feedback.
         * @param {any} responseData
         */
        showResult: function (responseData) {
            var color = 'black';

            if (responseData.Succesfully != undefined) {
                color = (responseData.Succesfully ? 'blue' : 'red');

                if (responseData.Message == undefined || responseData.Message == null) {
                    responseData.Message = (responseData.Succesfully ? "Saved" : "Error");
                }

                $('#Validation').attr('style', 'color:' + color);
                $('#Validation').text(responseData.Message);
            }
        },


        /**
         * submit form with action. Report result back by calling showResult
         * @param {string} idForm
         * @param {string} actionUrl
         * @param {boolean} navigateBack
         * @param {string} kendoWindowId
         */
        submitForm: async function (formId, actionUrl, navigateBack, kendoWindowId) {

            var validator = $('#' + formId).kendoValidator().data('kendoValidator');
            var response = "";
            kendo.ui.progress($(document.body), true);

            if (validator.validate()) {

                var serializeddata = $('#' + formId).serialize();

                await $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: appsettings.getUrl(actionUrl),
                    data: serializeddata,
                    success: function (responseData) {
                        response = responseData;

                        inputs.removeDirtyInput(); // remove dirty input

                        // redirect defined
                        if (responseData.RedirectTo != undefined) {
                            // succesfull callback 
                            if (responseData.Succesfully) {
                                location.href = appsettings.getUrl(responseData.RedirectTo);
                            }
                        }
                        else // if not
                        {
                            //// Show request result
                            form.showServerResponse(formId, responseData);

                            if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                                Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                            }

                            // When navigate back is true (as property given 'taghelper') and request is successfull. 
                            if (navigateBack && responseData.Succesfully) {

                                if (kendoWindowId == "") {
                                    if (history.length > 2) {
                                        history.back(); // go back one page using the breadcrumb hist.
                                    }
                                } else {
                                    var kendoWindow = $(kendoWindowId).data("kendoWindow");

                                    if (kendoWindow !== undefined) {
                                        kendoWindow.close();
                                    }
                                }
                            }
                        }

                    }

                });

            } else {
                kendo.ui.progress($(document.body), false);
                var errors = validator._errors;
                $(errors).each(function () {
                    console.log(this);
                });
            }

            return response;
        },

        /**
         * Create form buttons for the form
         * Part of the TagHelper 'FormButtonsTagHelper'
         * @param {number} idForm
         * @param {boolean} showResultInBrowser
         * @param {string} actionUrl
         * @param {string} redirectTo
         * @param {string} idCancel
         * @param {boolean} skipCancel
         * @param {string} idSubmit
         * @param {boolean} navigateBack
         * @param {string} kendoWindowId
         * @param {boolean} submitWithFile
         */
        createFormButtons: function (formid, actionUrl, idCancel, skipCancel, idSubmit, navigateBack, kendoWindowId, submitWithFile) {

            // Submit button
            $(idSubmit).kendoButton({
                themeColor: "primary",
                click: function () {
                    if (submitWithFile) {
                        submitFormWithFile(formid, actionUrl, navigateBack, kendoWindowId);
                    } else { 
                        form.submitForm(formid, actionUrl, navigateBack, kendoWindowId);
                    }
                }
            });

            // Cancel button
            if (!skipCancel) {
                $(idCancel).kendoButton({
                    themeColor: "secondary",
                    click: function () {
                        history.back();
                    }
                });
            }
        },

        /**
         * Ticket 1579650 - kendo issue reported hidden fields not working for tagHelper 
         * @param {any} container
         * @param {any} options
         */
        hiddenEditor: function (container, options) {
            $('<input type="hidden" data-bind="value: ' + options.field + '" name="' + options.field + '"/>')
                .appendTo(container);
        },

        /**
         * Show required tagged inputs 
         */
        //initialize: function () {
        //    $("input[input-precom-required = 'true']").parent().css("border-left", "3px solid red");
        //},

        /**
         * Give user feedback on the server response. When a error occurs, users are notified by a messagebox / dialog, otherwise the user will be informed with a toast message. 
         * @param {any} formId
         * @param {any} responseData
         */
        showServerResponse: function (formId, responseData, callBack) {
            kendo.ui.progress($(document.body), false);
            if (responseData != null && responseData != undefined) {

                if (!responseData.Succesfully && responseData.Message)  // Error (validation or anything other)
                {
                    main.openActionsDialog(' ',
                        responseData.Message, [{
                            text: 'Ok',
                            action: function () {
                                main.closePopup();
                            }, primary: true
                        }]);
                }
                else if (responseData.Succesfully)                      // Success Message 
                {                    
                    $("#staticNotification").kendoNotification({
                        appendTo: "#" + formId + " .precom-form-feedback",
                        autoHideAfter: WAIT_DELAY,
                        hide: onHide(callBack)                       
                    }).data("kendoNotification").show(" " + responseData.Message, "info");
                }
                else                                                    // Error with no info ^^
                {
                    $("#staticNotification").kendoNotification({
                        appendTo: "#" + formId + " .precom-form-feedback",
                        autoHideAfter: WAIT_DELAY
                    }).data("kendoNotification").show(" " + responseData.Message, "error");
                }
            }
        },

        /**
         * Create dialog
         */
        createDialog: function (title, message, buttonTextYes, callbackYes, buttonTextNo, callbackNo) {

            // Create the Kendo dialog
            $("#dialog").kendoDialog({
                width: "400px",
                title: title,
                closable: false,
                content: message,
                actions: [
                    { text: buttonTextYes, primary: true, action: callbackYes },
                    { text: buttonTextNo, action: callbackNo }
                ]
            });

        },


        closeDialog: function () {

            var dialog = $("#dialog").data("kendoDialog");
            if (dialog != undefined) {
                dialog.close();
            }

        },


        /**
         * Submit data
         * @param {any} formId
         * @param {any} actionUrl
         * @param {any} fieldName
         * @param {any} data
         * @param {any} navigateBack
         * @param {any} reload
         * @param {any} kendoElementId
         */
        submitData: function (formId, actionUrl, fieldName, data, navigateBack, reload, kendoElementId) {
            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: data,
                success: function (responseData) {

                    if (responseData.Succesfully) {
                        $(fieldName).text("");
                    }

                    // Show request result
                    form.showServerResponse(formId, responseData);

                    if (responseData.Succesfully) {

                        if (responseData.RedirectTo != undefined && responseData.RedirectTo != '') {
                            location.href = responseData.RedirectTo;
                        } else if (navigateBack) {

                            // When navigate back is true (as property given 'taghelper') and request is successfull. 
                            if (kendoElementId == "") {
                                history.back();
                            } else {
                                var kendoWindow = $(kendoElementId).data("kendoWindow");

                                if (kendoWindow !== undefined) {
                                    kendoWindow.close();
                                }
                            }
                        } else if (reload) {
                            var elementFound = false;
                            var kendoElement = $(kendoElementId);
                            if (kendoElement !== undefined) {
                                var kendoTabStrip = kendoElement.data("kendoTabStrip");
                                if (kendoTabStrip !== undefined) {
                                    elementFound = true;
                                    kendoTabStrip.reload(".k-active");
                                }
                            }

                            if (!elementFound) {
                                navigation.navigateToCurrentModule();
                            }
                        }
                    }
                }
            });
        },

        /**
         * delete Data
         * @param {any} formId
         * @param {any} actionUrl
         * @param {any} fieldName
         * @param {any} data
         * @param {any} navigateBack
         * @param {any} reload
         * @param {any} kendoElementId
         */
        deleteData: function (formId, actionUrl, fieldName, data, navigateBack, reload, kendoElementId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl(actionUrl),
                data: data,
                success: function (responseData) {

                    if (responseData.Succesfully) {
                        $(fieldName).text(""); // TODO:
                    }

                    // Show request result
                    form.showServerResponse(formId, responseData);

                    if (responseData.Succesfully) {
                        if (responseData.RedirectTo != undefined && responseData.RedirectTo != '') {
                            location.href = responseData.RedirectTo;
                        } else if (navigateBack) {
                            // When navigate back is true (as property given 'taghelper') and request is successfull. 
                            if (kendoElementId == "") {
                                history.back();
                            } else {
                                var kendoWindow = $(kendoElementId).data("kendoWindow");

                                if (kendoWindow !== undefined) {
                                    kendoWindow.close();
                                }
                            }
                        } else if (reload) {
                            var elementFound = false;
                            var kendoElement = $(kendoElementId);
                            if (kendoElement !== undefined) {
                                var kendoTabStrip = kendoElement.data("kendoTabStrip");
                                if (kendoTabStrip !== undefined) {
                                    elementFound = true;
                                    kendoTabStrip.reload(".k-active");                                    
                                }
                            }

                            if (!elementFound) {
                                navigation.navigateToCurrentModule();
                            }
                        }
                    }
                }
            });
        },
    }
}();